import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_API_URL;

export default function QuizResults() {
  const [rows, setRows] = useState([]);
  const [answerKey, setAnswerKey] = useState([]);

  async function load() {
    const res = await fetch(`${API}/quiz/results`);
    if (!res.ok) return;
    const data = await res.json();
    setRows(data.responses || []);
    setAnswerKey(data.quiz?.answerKey || []);
  }

  useEffect(() => { load(); }, []);

  return (
    <div className="max-w-5xl mx-auto p-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold text-[#000099]">Quiz – svar</h1>
        <button onClick={load} className="bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded">Oppdater</button>
      </div>

      <div className="overflow-x-auto bg-white rounded-xl shadow">
        <table className="min-w-full">
          <thead className="bg-gray-100">
            <tr>
              <th className="text-left px-3 py-2">Tid</th>
              <th className="text-left px-3 py-2">Navn</th>
              <th className="text-left px-3 py-2">Telefon</th>
              <th className="text-left px-3 py-2">Score</th>
              <th className="text-left px-3 py-2">Svar</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} className="border-t">
                <td className="px-3 py-2">{new Date(r.createdAt).toLocaleString('no-NO')}</td>
                <td className="px-3 py-2">{r.full_name}</td>
                <td className="px-3 py-2">{r.phone}</td>
                <td className="px-3 py-2 font-semibold">{r.score}/10</td>
                <td className="px-3 py-2">
                  <div className="flex gap-1 flex-wrap">
                    {r.answers.map((a, i) => {
                      const ok = a === answerKey[i];
                      return (
                        <span key={i}
                          className={`px-2 py-0.5 rounded text-xs ${ok ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                          Q{i+1}:{a}
                        </span>
                      );
                    })}
                  </div>
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td className="px-3 py-4 text-gray-500" colSpan={5}>Ingen svar ennå.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
